import { ChartPie, CloudCheck, CloudOff, House, Plus, ReceiptText, RefreshCw, Settings, Shapes } from 'lucide-react';
import { NavLink, Outlet } from 'react-router';
import { formatDistanceToNow } from 'date-fns';

import { useApp } from '@/lib/hooks';
import { syncNow } from '@/lib/store';

import { EditorProvider, useExpenseEditor } from './ExpenseEditor';
import { Button, IconButton } from './ui';

const NAV = [
  { to: '/', label: 'Dashboard', icon: House, end: true },
  { to: '/expenses', label: 'Expenses', icon: ReceiptText },
  { to: '/insights', label: 'Insights', icon: ChartPie },
  { to: '/categories', label: 'Categories', icon: Shapes },
  { to: '/settings', label: 'Settings', icon: Settings },
];

function SyncStatus() {
  const { sync, syncMessage, lastSyncAt } = useApp();
  const text =
    sync === 'syncing'
      ? 'Syncing…'
      : syncMessage ?? (lastSyncAt ? `Synced ${formatDistanceToNow(new Date(lastSyncAt), { addSuffix: true })}` : '');
  const Icon = sync === 'offline' || sync === 'error' ? CloudOff : CloudCheck;
  return (
    <div className="row faint" style={{ fontSize: 12, gap: 6 }}>
      <Icon size={14} />
      <span className="ellipsis" style={{ flex: 1 }}>
        {text}
      </span>
      <IconButton icon={RefreshCw} label="Sync now" onClick={() => void syncNow()} style={{ width: 28, height: 28 }} />
    </div>
  );
}

export function Layout() {
  const { user } = useApp();
  const editor = useExpenseEditor();
  return (
    <EditorProvider value={editor.api}>
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">
          <img src="/app/favicon.svg" alt="" />
          Spendly
        </div>
        <Button icon={Plus} block onClick={() => editor.open()} style={{ marginBottom: 14 }}>
          Add expense
        </Button>
        <nav className="nav">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end}>
              <Icon size={19} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-foot">
          <SyncStatus />
          <div className="faint" style={{ fontSize: 13 }}>
            {user?.firstName || user?.phone}
          </div>
        </div>
      </aside>

      <div className="main">
        <header className="mobile-bar">
          <div className="brand" style={{ padding: 0 }}>
            <img src="/app/favicon.svg" alt="" />
            Spendly
          </div>
          <Button icon={Plus} onClick={() => editor.open()}>
            Add
          </Button>
        </header>
        <Outlet />
        <nav className="bottom-nav">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end}>
              <Icon size={20} />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
      {editor.element}
    </div>
    </EditorProvider>
  );
}
